import { render, staticRenderFns } from "./stockQty.vue?vue&type=template&id=8756b3fa&scoped=true&"
import script from "./stockQty.vue?vue&type=script&lang=js&"
export * from "./stockQty.vue?vue&type=script&lang=js&"
import style0 from "./stockQty.vue?vue&type=style&index=0&id=8756b3fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8756b3fa",
  null
  
)

export default component.exports